export const APP_NAME = 'main-client';
export const APP_VERSION = '2.34.5';
